module.exports = __webpack_public_path__ + "static/media/checkmark.29fe6f2f.svg";